/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpRespNotListedContent_user$ref = any;
type PdpRespSimilarItemsGrid_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespContainerNotListed_user$ref: FragmentReference;
export type PdpRespContainerNotListed_user = {|
  +$fragmentRefs: PdpRespSimilarItemsGrid_user$ref & PdpRespNotListedContent_user$ref,
  +$refType: PdpRespContainerNotListed_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespContainerNotListed_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsGrid_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespNotListedContent_user",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '426a53354b4dfe437c5c9992f49e270c';
module.exports = node;
